const finalResultGoL = {
  bostrom1qs9w7ry45axfxjgxa4jmuhjthzfvj78sxh5p6e: {
    gift: 700000000000000.0,
    total: 700000000000000.0,
  },
  bostrom1xszmhkfjs3s00z2nvtn7evqxw3dtus6yr8e4pw: {
    cybercongress: 115880796057845.0,
    total: 115880796057845.0,
  },
  bostrom1jv65s3grqf6v6jl3dp4t6c9t9rk99cd8yvs0hc: {
    cybersenate: 50726497621325.0,
    total: 50726497621325.0,
  },
  bostrom1ha4pw9w2qgc2ce9jwfrwrmaft5fneus58nqwev: {
    greatweb_foundation: 50000000000000.0,
    total: 50000000000000.0,
  },
  bostrom1qn8sr2hzmktlecusdtxj9hwj0upnm0jft9snar: {
    'gol.load': 93872815.0,
    'investors.genesis': 4000000000000.0,
    'investors.port': 1265001729654.0,
    'investors.takeoff': 4887205664742.0,
    total: 10152301267211.0,
  },
  bostrom16230lc9r27vrxlzd4wlvcz2l66quzj84vlkxc5: {
    inventors: 10000000000000.0,
    total: 10000000000000.0,
  },
  bostrom1gxhs5wzam5rlgf6cs0lkme400ut64d4ncpfs2h: {
    inventors: 10000000000000.0,
    total: 10000000000000.0,
  },
  bostrom1qwzsnnuk2u6avvh059c9p50gqqquvcu5svvwrs: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1s4czxghmh29aw2ldynk8r9lnkfccw5ph8rjpxa: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1m8yf3g2m9p7danjvt4ga6vzewy380pk52kcu9z: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1g07gj9ph0r2hjx6ffqn8vl38u4agd5mpqx9m7f: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1pntx8ql2v7cqxu05etg8c4v0r2vz7qnq9uqmpy: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1ttd4h585vgy29gj0xe0p338drvw9w4m4hzwj9p: {
    'investors.genesis': 4000000000000.0,
    total: 4000000000000.0,
  },
  bostrom1edlrze5f48jjaw0wxcve4asqqf2tcjdl59ln8q: {
    'investors.genesis': 2000000000000.0,
    total: 2000000000000.0,
  },
  bostrom1t3222ju7ssu58xsm3m2xw445p94cqn2qrex3vy: {
    'investors.genesis': 2000000000000.0,
    total: 2000000000000.0,
  },
  bostrom10c8znaj94y900syues06dz50hw6y9qpkhunn25: {
    'grants.init_implementation': 1000000000000.0,
    'investors.genesis': 400000000000.0,
    total: 1400000000000.0,
  },
  bostrom1s3lgc3mgy4ltwr796qk6j73xmau4njueds0mgu: {
    'investors.takeoff': 1340337491769.0,
    total: 1340337491769.0,
  },
  bostrom10556xtnp39nvx3ec3yjafug662pyt6af84n477: {
    'investors.takeoff': 1304153455839.0,
    total: 1304153455839.0,
  },
  bostrom1fe5mspz9jsq6p9hqqet86dwp276635l6gacspa: {
    'grants.cyberdbot': 200000000.0,
    'investors.genesis': 1000000000000.0,
    total: 1000200000000.0,
  },
  bostrom17a7xxqa4drnalvv7pkxrkxqer953fdke3ulwx4: {
    'investors.genesis': 1000000000000.0,
    total: 1000000000000.0,
  },
  bostrom1ngd5w7j4u5ar5xh7vzuwqqznnhhcjmnz0s6kpu: {
    'investors.genesis': 1000000000000.0,
    total: 1000000000000.0,
  },
  bostrom194pp2whvqynxnfyw5tqy8fzy2kxsugyrwsaynk: {
    'investors.genesis': 1000000000000.0,
    total: 1000000000000.0,
  },
  bostrom1s4wntr9selfaznc2ezjkwnwt2y0terx9tqpda3: {
    'investors.genesis': 1000000000000.0,
    total: 1000000000000.0,
  },
  bostrom10e3rqclgjz4m4fnx2c23jupcjpyuvyx3x4k7qj: {
    'investors.genesis': 1000000000000.0,
    total: 1000000000000.0,
  },
  bostrom1ffve0zx389ffl80ae9t8jmghcjuzdlqr5eayfd: {
    'investors.takeoff': 701778551659.0,
    total: 701778551659.0,
  },
  bostrom1ftah3e558ww7xutn5w8h7vrqa9v69pntztnr3p: {
    'investors.takeoff': 622444466499.0,
    total: 622444466499.0,
  },
  bostrom1wnpak7sfawsfv9c8vqe7naxfa4g99lv77d7c0z: {
    'gol.load': 192458910.0,
    'gol.relevance': 1750177336.0,
    'gol.sergeandmyself': 45500000000.0,
    'investors.port': 658125569.0,
    'investors.takeoff': 469321209467.0,
    total: 517421971282.0,
  },
  bostrom14nzyt8wmx4g6zkeluelukamgsh5v4xgnc25k6j: {
    'investors.genesis': 400000000000.0,
    'investors.takeoff': 108729659282.0,
    total: 508729659282.0,
  },
  bostrom1sng0f47cuvx6edxaujh24wc3dvk94q0w6r6smh: {
    'gol.load': 3927733.0,
    'investors.genesis': 400000000000.0,
    'investors.takeoff': 74217807211.0,
    total: 474221734944.0,
  },
  bostrom1quchyywzdxp62dq3rwan8fg35v6j58sjwnfpuu: {
    'gol.comm_pool': 400000000000.0,
    'gol.relevance': 32771825520.0,
    total: 432771825520.0,
  },
  bostrom1mcslqq8ghtuf6xu987qtk64shy6rd86a2xtwu8: {
    'investors.genesis': 400000000000.0,
    total: 400000000000.0,
  },
  bostrom1679yrs8dmska7wcsawgy2m25kwucm3z0hwr74y: {
    'gol.load': 264078762041.0,
    'gol.relevance': 120664978934.0,
    'investors.takeoff': 4225275377.0,
    total: 388969016352.0,
  },
  bostrom1hmkqhy8ygl6tnl5g8tc503rwrmmrkjcq3lduwj: {
    'gol.delegation': 44520253098.0,
    'gol.lifetime': 27210367043.0,
    'gol.load': 4614693334.0,
    'gol.relevance': 10420579129.0,
    'heroes.euler4': 294594691430.0,
    'heroes.pre_bostrom': 4976065872.0,
    total: 386336649906.0,
  },
  bostrom1ymprf45c44rp9k0g2r84w2tjhsq7kalv98rgpt: {
    'gol.delegation': 47418074597.0,
    'gol.lifetime': 30517372757.0,
    'gol.load': 11978014123.0,
    'gol.relevance': 26452621959.0,
    'heroes.euler4': 249028568078.0,
    'heroes.pre_bostrom': 3704750054.0,
    total: 369099401568.0,
  },
  bostrom1d8754xqa9245pctlfcyv8eah468neqzn3a0y0t: {
    'gol.load': 7069919.0,
    'gol.relevance': 232748525.0,
    'investors.genesis': 360000000000.0,
    total: 360239818444.0,
  },
  bostrom1sgy27lctdrc5egpvc8f02rgzml6hmmvh5wu6xk: {
    'investors.takeoff': 359172486938.0,
    total: 359172486938.0,
  },
  bostrom12psudf4rpaw4jwhuyx3y8sejhsynae7gv53hn6: {
    'gol.delegation': 9428419501.0,
    'gol.lifetime': 21663954767.0,
    'heroes.euler4': 289014488663.0,
    total: 320106862931.0,
  },
  bostrom178q202gz0093uke0jy96psyya452rt8apl4has: {
    'heroes.euler4': 285239999451.0,
    total: 285239999451.0,
  },
  bostrom1cg79pj70mgl8xlum0rw5yy6enk9jszsrzvwysn: {
    'gol.load': 49096661.0,
    'investors.port': 947937939.0,
    'investors.takeoff': 278433789365.0,
    total: 279430823965.0,
  },
  bostrom1w4tvyvf3hhpcwv9d4axa8n0mmj5d6ypvpq5mj6: {
    'investors.port': 278432605496.0,
    total: 278432605496.0,
  },
  bostrom13dpy00jest96g7h5vdgvg9zpxq6xnclh5hzw5l: {
    'investors.takeoff': 258229369437.0,
    total: 258229369437.0,
  },
  bostrom1kr6udadsvdjymq6m75un4khg27t25st2jn8sag: {
    'heroes.euler4': 255496772589.0,
    total: 255496772589.0,
  },
  bostrom1mdq5r6az6z8su68zj6px88j2ukr78ea4ggkzt6: {
    'investors.takeoff': 237448433882.0,
    total: 237448433882.0,
  },
  bostrom1xk4a2u2rjt7mqu5eg8xtxk37l28r3cugkqk9lp: {
    'investors.port': 233157212646.0,
    total: 233157212646.0,
  },
  bostrom177y7sqkxmvl22j632haf8y9gv0j3wedssq5m50: {
    'gol.delegation': 20500567008.0,
    'gol.lifetime': 24014339467.0,
    'gol.load': 28672450.0,
    'gol.relevance': 16249193036.0,
    'heroes.euler4': 161772072332.0,
    'heroes.pre_bostrom': 5313581537.0,
    total: 227878425830.0,
  },
  bostrom1w8ap0ns4d5fagjfwvph6t99uet0cwv6y6r03un: {
    'heroes.euler4': 200997782490.0,
    total: 200997782490.0,
  },
  bostrom1svm5wl5jf4p7dwemj7wh0p4egr3js6rqtlnefu: {
    'heroes.euler4': 197153970492.0,
    total: 197153970492.0,
  },
  bostrom1gnnd2eaeqpp6lsd34tnp6j0m85h6r9qg0wh3vr: {
    'heroes.euler4': 194917719034.0,
    total: 194917719034.0,
  },
  bostrom1t0hmc79ht0qja92p6qgxn3ee3a3rzqutv7thqn: {
    'heroes.euler4': 188630461585.0,
    total: 188630461585.0,
  },
  bostrom1ggc9sqvj0uhnzwxu5dyzcr05shwd2vv2guqmas: {
    'gol.lifetime': 6732817375.0,
    'gol.load': 1178320.0,
    'heroes.euler4': 180243413335.0,
    'heroes.pre_bostrom': 1171125807.0,
    total: 188148534837.0,
  },
  bostrom12q68xfj4r00nxnjrqk742rf0z2w6jmwaeppvr0: {
    'heroes.euler4': 183750995527.0,
    total: 183750995527.0,
  },
  bostrom1lepnu7nt05g79jtmfp2pgrpys3fjc4p74sc0l2: {
    'investors.takeoff': 182911039870.0,
    total: 182911039870.0,
  },
  bostrom1zhy7l8phhpsm2c6xl9c5arcu0z90clynluwrw5: {
    'heroes.euler4': 161481707259.0,
    total: 161481707259.0,
  },
  bostrom1d5lu67hu3lhqtw6zyv7uy4gkfpdtfnzxdu6mrq: {
    'investors.takeoff': 157995617348.0,
    total: 157995617348.0,
  },
  bostrom1zy553za8nenzukmv65240323jhuvxzym4pl6w9: {
    'gol.delegation': 22107148994.0,
    'gol.lifetime': 13440309740.0,
    'gol.load': 44831928383.0,
    'gol.relevance': 1160221687.0,
    'heroes.pre_bostrom': 728651051.0,
    'investors.takeoff': 72024951997.0,
    total: 154293211852.0,
  },
  bostrom1x95keq9l9y9p7hjdt6xd8wnknrpnjsqrqhpwc9: {
    'gol.comm_pool': 150000000000.0,
    total: 150000000000.0,
  },
  bostrom1k60sfzh3ecyqfv36f7zav0089077e4zk4g6mxa: {
    'heroes.euler4': 146840247453.0,
    total: 146840247453.0,
  },
  bostrom16jttzjgks48kqrhk5e68yv0gv6dt0rpw2f5pwn: {
    'investors.takeoff': 141302079887.0,
    total: 141302079887.0,
  },
  bostrom1kpep8dl93ud4wgpws3tcew6as2s36c9v3csw89: {
    'heroes.euler4': 140997260087.0,
    total: 140997260087.0,
  },
  bostrom16lvsv3w7rnhcm079v6j9eah3xd0p3pd37hl48j: {
    'heroes.euler4': 122742180846.0,
    total: 122742180846.0,
  },
  bostrom1ke7kxdn29w2lrxt9dzusa6shvmwd8xm9gxm2zf: {
    'gol.delegation': 37576877634.0,
    'gol.lifetime': 4443209216.0,
    'gol.relevance': 73420928895.0,
    'heroes.pre_bostrom': 5147839273.0,
    total: 120588855018.0,
  },
  bostrom1e20hw2pqcgxvumkwn2qeeavcrswzskzjhr2aq0: {
    'gol.load': 785547.0,
    'investors.takeoff': 119453574443.0,
    total: 119454359990.0,
  },
  bostrom1dt9lwmuq8rkngm5gajxchqhpcnavgp7md9v929: {
    'gol.delegation': 9987047512.0,
    'gol.lifetime': 10957918915.0,
    'gol.load': 321681321.0,
    'gol.relevance': 46807970.0,
    'heroes.euler4': 90918587064.0,
    'heroes.pre_bostrom': 2885250571.0,
    total: 115117293353.0,
  },
  bostrom1mnrwpdlnglhtqwa55fa66va0j3fv72nvkz4e2x: {
    'gol.delegation': 1737571043.0,
    'gol.lifetime': 6897780406.0,
    'gol.load': 1571093.0,
    'heroes.euler4': 106192910312.0,
    total: 114829832854.0,
  },
  bostrom15zs0cjct43xs4z4sesxcrynar5mxm82f0ykhl3: {
    'gol.delegation': 15464386326.0,
    'gol.lifetime': 20503040116.0,
    'gol.load': 29730581092.0,
    'gol.relevance': 3719085456.0,
    'heroes.euler4': 37624877989.0,
    'heroes.pre_bostrom': 4090023363.0,
    total: 111131994342.0,
  },
  bostrom1xvssufw8ke03halg8wgu8m994ktxz0y9vm6tqn: {
    'gol.comm_pool': 100000000000.0,
    total: 100000000000.0,
  },
  bostrom1z98eg2ztdp2glyla62629nrlvczg8s7fvc0znp: {
    'gol.comm_pool': 100000000000.0,
    total: 100000000000.0,
  },
  bostrom1vtu55cc7m6yz9zfg5vqdk80f2g68petgzj9fv4: {
    'gol.comm_pool': 100000000000.0,
    total: 100000000000.0,
  },
  bostrom1vxxfhd8txmrq76jx3gj7sdrvg0vvqret6kxpgd: {
    'gol.comm_pool': 100000000000.0,
    total: 100000000000.0,
  },
  bostrom1dxpm2ne0jflzr2hy9j5has6u2dvfv68calunqy: {
    'gol.delegation': 4744433641.0,
    'gol.lifetime': 15809132022.0,
    'heroes.euler4': 74273271492.0,
    'heroes.pre_bostrom': 4988415157.0,
    total: 99815252312.0,
  },
  bostrom16macu2qtc0jmqc7txvf0wkz84cycsx728ah0xc: {
    'gol.load': 16103705.0,
    'gol.relevance': 55778469820.0,
    'investors.takeoff': 42201602776.0,
    total: 97996176301.0,
  },
  bostrom18naxcfp2s397a2ucav2m53f003uylk3qz9fvr7: {
    'gol.delegation': 15259397818.0,
    'gol.lifetime': 26399274499.0,
    'gol.load': 26611568430.0,
    'gol.relevance': 2462577501.0,
    'heroes.euler4': 19980209562.0,
    'heroes.pre_bostrom': 4142711286.0,
    'investors.port': 658690702.0,
    total: 95514429798.0,
  },
  bostrom17z2fywzrdld7qmwzpsq0atxfwcns8rp833rgxy: {
    'investors.takeoff': 95223358775.0,
    total: 95223358775.0,
  },
  bostrom1tu0e0ggvjtv4gvzcranjnrykac0umnf8y8fm0r: {
    'investors.takeoff': 92010985676.0,
    total: 92010985676.0,
  },
  bostrom1sltcfypwms38jjj3g38rg7ldx3e6uqrzrnkf9y: {
    'investors.takeoff': 91965450766.0,
    total: 91965450766.0,
  },
  bostrom1en69twaxmv7xupy8lq7y539dpecx7yz8g0k8ft: {
    'gol.delegation': 18669971823.0,
    'gol.lifetime': 24919735783.0,
    'gol.load': 5528676770.0,
    'gol.relevance': 301861873.0,
    'heroes.euler4': 35149508757.0,
    'heroes.pre_bostrom': 3870252487.0,
    total: 88440007493.0,
  },
  bostrom12xsg4qm4k5z48s79zdsz84jlhv56kmta3vyfvl: {
    'heroes.euler4': 74772629353.0,
    total: 74772629353.0,
  },
  bostrom1f7nx65pmayfenpfwzwaamwas4ygmvalq2q2ayq: {
    'gol.delegation': 47095487433.0,
    'gol.lifetime': 20394243142.0,
    'heroes.euler4': 2952355930.0,
    'heroes.pre_bostrom': 2895940703.0,
    total: 73338027208.0,
  },
  bostrom1daxxqs56f6j5qxxtjrjkexghsmnaj66tejshc8: {
    'gol.delegation': 45885621564.0,
    'gol.lifetime': 23275608448.0,
    'heroes.pre_bostrom': 3760032860.0,
    total: 72921262872.0,
  },
  bostrom152m9xcx0ht7yxr5834ju7qjcyvetw8amd04apw: {
    'gol.delegation': 26069696989.0,
    'gol.lifetime': 15467407648.0,
    'gol.load': 25296563469.0,
    'heroes.pre_bostrom': 4504119534.0,
    total: 71337787640.0,
  },
  bostrom1lnkg57t7mvg5mcl7kdkevtgr9wlf6f9qtp86sk: {
    'gol.delegation': 4338666110.0,
    'gol.lifetime': 14835497059.0,
    'gol.load': 322859641.0,
    'heroes.euler4': 50221478847.0,
    'heroes.pre_bostrom': 1188688448.0,
    total: 70907190105.0,
  },
  bostrom1my32szlwazg9x56xqvsvtp0hqvpzm0r4u3k4ae: {
    'gol.lifetime': 92845309.0,
    'heroes.euler4': 70179119586.0,
    total: 70271964895.0,
  },
  bostrom1g0ap9fvex93yzzj69uzl74942vjvq8e4f8xtyr: {
    'heroes.euler4': 67992083477.0,
    total: 67992083477.0,
  },
  bostrom16zms8r32vad3z8hl2vc6wrcnanwmxf0dgh25yp: {
    'heroes.euler4': 67229160818.0,
    total: 67229160818.0,
  },
  bostrom18z9vsjffvggluxcxfqwsmrz02v37hx2e3auyn2: {
    'gol.lifetime': 5741693919.0,
    'heroes.euler4': 57929970902.0,
    total: 63671664821.0,
  },
  bostrom1d3zlsrjyl3tzp3aly7vjduhrtrtvkvkeaqpdku: {
    'heroes.euler4': 63422106566.0,
    total: 63422106566.0,
  },
  bostrom1stfw0z5nf2ncxxtrk7zndpf2dla3nh379egwcy: {
    'gol.delegation': 11914393376.0,
    'gol.lifetime': 11189940762.0,
    'gol.load': 36938756433.0,
    'gol.relevance': 1635757102.0,
    total: 61678847673.0,
  },
  bostrom18jwk949jqgq3j2du2dgscqxqkkqw5rsjfuucf3: {
    'heroes.euler4': 61558395847.0,
    total: 61558395847.0,
  },
  bostrom13fwhvawke6867s6raqux25fd24t89j5h8wf2v0: {
    'heroes.euler4': 60883067675.0,
    total: 60883067675.0,
  },
  bostrom1lpfs6xv765u4yxr8rlyn5ux0g2a8tyt90hsnas: {
    'investors.takeoff': 59256843788.0,
    total: 59256843788.0,
  },
  bostrom147rnn0rxqkythj4j9ccq0kytmh7f005rn0a3zj: {
    'gol.delegation': 11199572491.0,
    'gol.lifetime': 13133148758.0,
    'gol.load': 30186983650.0,
    'gol.relevance': 792143948.0,
    total: 55311848847.0,
  },
  bostrom1njsr8tngxtygsc73mrtn5738ztkzqy7c7y7h3t: {
    'gol.delegation': 15230667266.0,
    'gol.lifetime': 17888573509.0,
    'heroes.pre_bostrom': 3209803615.0,
    'investors.takeoff': 14737589328.0,
    total: 51066633718.0,
  },
  bostrom1argjwgcplguenq4l92ggn06wadnfrz0ecqrmqs: {
    'gol.delegation': 20472680990.0,
    'gol.lifetime': 24506572852.0,
    'heroes.pre_bostrom': 5612582845.0,
    total: 50591836687.0,
  },
  bostrom1smqr5tp684g07aekcn0w852wqlme5mn6dmsny3: {
    'investors.takeoff': 47098839942.0,
    total: 47098839942.0,
  },
  bostrom1dl5df5g2xwj02e93k547etw2ergvc3a20v5ekz: {
    'heroes.euler4': 46480474242.0,
    total: 46480474242.0,
  },
  bostrom1eqkdzfcjnu20ywju35rf3nutxzjxjaqnxqfyyz: {
    'investors.takeoff': 44081312892.0,
    total: 44081312892.0,
  },
  bostrom1ldjugf3uj2gwkmmsf5japfknf96zv6hw7xw7v4: {
    'gol.delegation': 102675.0,
    'gol.lifetime': 2388287319.0,
    'heroes.euler4': 40841467077.0,
    total: 43229857071.0,
  },
  bostrom1waac73cpffx7suhpkvnn8w0a8s2cgzn66x2aka: {
    'investors.takeoff': 42415701749.0,
    total: 42415701749.0,
  },
  bostrom13ume6mqte5h9ngx2hh6ngc8aham7x0k6stuvkm: {
    'heroes.euler4': 41813199988.0,
    total: 41813199988.0,
  },
  bostrom1y9zkl7uqjev899swng4eqfuurwaxpchwppewyc: {
    'heroes.euler4': 40330418998.0,
    total: 40330418998.0,
  },
  bostrom14d92r4svhl4qa3g6q48tjekarw2kt67ngqn4lr: {
    'investors.genesis': 40000000000.0,
    total: 40000000000.0,
  },
  bostrom19ys53t55r725j882gjcrnf7s449gdrds3h2hu4: {
    'gol.load': 1274549312.0,
    'gol.relevance': 70470760.0,
    'heroes.euler4': 36908973741.0,
    total: 38253993813.0,
  },
  bostrom16lf2hvzy4n4gvtx37pgkkdw2e2psfjjdpej53p: {
    'heroes.euler4': 37988147654.0,
    total: 37988147654.0,
  },
  bostrom1fapqgamx3c8za8d3z56sydjtjygyu0ly752j8g: {
    'investors.takeoff': 37850807372.0,
    total: 37850807372.0,
  },
  bostrom1v5jqg6k7mszmchhz8kyfml5h4e2txct9jz3am4: {
    'heroes.euler4': 37418729590.0,
    total: 37418729590.0,
  },
  bostrom1x7wp0u877dkw7m84jv54c9g6zpd5r8t2nm47gn: {
    'gol.relevance': 33812731064.0,
    total: 33812731064.0,
  },
  bostrom1w4548vrnvc7t9j2ly55nvkjvhwqt9thnfcvuw6: {
    'investors.takeoff': 33395512349.0,
    total: 33395512349.0,
  },
  bostrom1ccvpcq9ffy0qd2ca8nmmpzfamtyjfc9znwak8m: {
    'gol.delegation': 19689711316.0,
    'gol.lifetime': 9472498458.0,
    'heroes.pre_bostrom': 3477642735.0,
    total: 32639852509.0,
  },
  bostrom133t8m00w7llsslnf05zdhehharntly8dqzpfs8: {
    'investors.takeoff': 31992273571.0,
    total: 31992273571.0,
  },
  bostrom1kgq82m6z2jttytv7fvwy2rklhq5k03gc2h9sej: {
    'heroes.euler4': 30494554808.0,
    total: 30494554808.0,
  },
  bostrom1smtmk8fe3qhlwj3h7nynl6p42946qydzvgj9va: {
    'investors.takeoff': 29390986364.0,
    total: 29390986364.0,
  },
  bostrom1hvk6s053m6qdlz9kwllgldwf4qp2c3mrlh9s2q: {
    'heroes.euler4': 29370149824.0,
    total: 29370149824.0,
  },
  bostrom152kqs8p7d3jy6kn4uk87ve3alkuqjgewt3cmvz: {
    'gol.lifetime': 4121615983.0,
    'heroes.euler4': 24799790071.0,
    total: 28921406054.0,
  },
  bostrom1gss7y04dky2fykck4dyp0pe39wxawlxm2l0yj2: {
    'gol.relevance': 28704261935.0,
    total: 28704261935.0,
  },
  bostrom1ch6nukdgj55c9sk4h5t8spzhahuuvn86gqvarm: {
    'heroes.euler4': 27485323135.0,
    total: 27485323135.0,
  },
  bostrom1rqudjcrdwqedffxufmqgsleuguhm7pkaq0alce: {
    'heroes.euler4': 27363284437.0,
    total: 27363284437.0,
  },
  bostrom1qgqkc9t3pfsp6yxjwds70e4r9y0p6resmfnymc: {
    'heroes.euler4': 26376882296.0,
    total: 26376882296.0,
  },
  bostrom12kd8w45rqxuwpwqvpmdyvvdey9ezeqhav4nn85: {
    'heroes.euler4': 26208333897.0,
    total: 26208333897.0,
  },
  bostrom16yf94eecl6h44l5w7zp75skh3rg0k4veavx762: {
    'gol.comm_pool': 15000000000.0,
    'gol.load': 10185396846.0,
    total: 25185396846.0,
  },
  bostrom1dn09uyhwmv3ratntc7c603vczgrec32c2fylpj: {
    'heroes.euler4': 24175157388.0,
    total: 24175157388.0,
  },
  bostrom1qezgmksavgdvcvf9ckhazfy3jfw8whhzfrvtlz: {
    'heroes.euler4': 21979059507.0,
    total: 21979059507.0,
  },
  bostrom1d552nfgekkugdgxw3zl242qpxapl67jfkz76tp: {
    'heroes.euler4': 21555502893.0,
    total: 21555502893.0,
  },
  bostrom1cerh237zd5rdexptjw8ryhwdf2tc9eupz7sfn0: {
    'gol.relevance': 20918517127.0,
    total: 20918517127.0,
  },
  bostrom10vpygn9ftv85ra7j7qpewuq5jdgvpjmehlds0g: {
    'heroes.euler4': 20335729382.0,
    total: 20335729382.0,
  },
  bostrom1teuan269feyw4ax94jfp4pcgrhqnn28gxxz8mw: {
    'gol.load': 1178320.0,
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 20000000000.0,
    total: 20201178320.0,
  },
  bostrom19rtverjn8kw7dzwzch2elktxgcmak6dlqugxfw: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1d6nkeqxmme3564wd889kr6cjed3asxqzjve0wl: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1d9en5u0cfaucavx848qeq4k6ywqd3z5d5a778h: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1djdfq5mn3dzm9whpznczxz77s8ep2qggc5w5xn: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1tcnlvf6qhlc3x7ax2vk3vzhxhf8wy8xrnjl72d: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1edwwsevuywe3sx82sustvyx3f3cvjt44ugccgy: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1z8fyzv3mjfccvrxhckr2u3lnc0hrgrlm4zkf8c: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom1gcy4f6f2sc73aegd9r68rt2q6teekl6swjva3p: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom17ud38eyfkd800kvw3c9kl3zpvgvj296nfszelr: {
    'gol.sergeandmyself': 20000000000.0,
    total: 20000000000.0,
  },
  bostrom18t3kx877vyvstcvn50cgn5w6hppe8ce0pq72m2: {
    'heroes.euler4': 18546327724.0,
    total: 18546327724.0,
  },
  bostrom1csf3up94qheqz88fvvlwjl7vc5sdymarktrvpw: {
    'investors.takeoff': 18442151620.0,
    total: 18442151620.0,
  },
  bostrom1kfqv2fzzu6dgwnf6snql2jslwdws07fl2gz37u: {
    'heroes.euler4': 17879700159.0,
    total: 17879700159.0,
  },
  bostrom1ggayl03vvv763az6eez66jzwuunyqkcusk8fwj: {
    'heroes.euler4': 17754934798.0,
    total: 17754934798.0,
  },
  bostrom1fjeq0urgk4x0s6pl2p2fes8c95426amp7lv4dv: {
    'heroes.euler4': 17601345097.0,
    total: 17601345097.0,
  },
  bostrom1tr3eyy9l480pxjk0ygudwpfus7j8pgdljn09jm: {
    'investors.takeoff': 17537519175.0,
    total: 17537519175.0,
  },
  bostrom16ahkkv0jzhtp73z83qlhqrypss6jpjm8eekpwv: {
    'investors.takeoff': 17375703563.0,
    total: 17375703563.0,
  },
  bostrom1jgh7ghrcr47tuahawzvg3svv2hxkxfx5u9lzr2: {
    'heroes.euler4': 17333444802.0,
    total: 17333444802.0,
  },
  bostrom1htq7u8gy9muv4fk6st04524tdzy8rv04528gys: {
    'investors.takeoff': 16744189104.0,
    total: 16744189104.0,
  },
  bostrom1402rpwdquxxkgvl740f6w69l65eau5vkqcvrax: {
    'gol.delegation': 7159491819.0,
    'gol.lifetime': 3246938813.0,
    'heroes.pre_bostrom': 5177873080.0,
    'investors.port': 949629027.0,
    total: 16533932739.0,
  },
  bostrom1kk9clwd4eva7ww95gn4rw3xzuwfs0983sl5cwt: {
    'investors.takeoff': 16191669541.0,
    total: 16191669541.0,
  },
  bostrom1mnfalar08dsvtwutmh43lnhx2zzmq7xhdulemj: {
    'gol.delegation': 6402703804.0,
    'gol.lifetime': 8540100989.0,
    'heroes.pre_bostrom': 650057544.0,
    total: 15592862337.0,
  },
  bostrom1s2a7rckcky6jmhncxwy0xtwf2ymg87puk6jpzz: {
    'gol.load': 2752947960.0,
    'gol.relevance': 2774105228.0,
    'investors.port': 218362161.0,
    'investors.takeoff': 9246030793.0,
    total: 14991446142.0,
  },
  bostrom1fz799u9jc0umceng3nkjt0njxy6y3550uq06jn: {
    'gol.relevance': 14973655085.0,
    total: 14973655085.0,
  },
  bostrom1k7cl9ya9qq30c7m4rvg3823hrc8k80eetqvhj8: {
    'investors.takeoff': 14797976623.0,
    total: 14797976623.0,
  },
  bostrom16d69u47km5vqdvf6fr8qyhktlacgka7fdvazr8: {
    'investors.takeoff': 14751375909.0,
    total: 14751375909.0,
  },
  bostrom16h7tyj5p69t3r7qasunf938cx2elp38fhqc7zr: {
    'gol.delegation': 2062295417.0,
    'gol.lifetime': 10620434968.0,
    'heroes.pre_bostrom': 1768330300.0,
    total: 14451060685.0,
  },
  bostrom19y467lyhqlpa52y6snq9cxw47xhwq0th3p05r0: {
    'heroes.euler4': 14256149914.0,
    total: 14256149914.0,
  },
  bostrom16ge9uqpqf78jdt0uz58ycalhtg59w77qm9t7d2: {
    'heroes.euler4': 14222312706.0,
    total: 14222312706.0,
  },
  bostrom1lljcf37yxh24l3v4kwqsyghwz4ywlg6urg4kte: {
    'gol.lifetime': 1970857840.0,
    'heroes.euler4': 11645695552.0,
    total: 13616553392.0,
  },
  bostrom1cjyv02cja896rr5y5lks79enk2nretn3mqyc69: {
    'gol.delegation': 2147705260.0,
    'gol.lifetime': 8731817017.0,
    'gol.load': 175176885.0,
    'heroes.euler4': 1417622893.0,
    'heroes.pre_bostrom': 975436233.0,
    total: 13447758288.0,
  },
  bostrom1463la66ac89tmlwgvx20c4d2jv84ekzs8kzh87: {
    'heroes.euler4': 13368713572.0,
    total: 13368713572.0,
  },
  bostrom1zeg2k7kd8qadmwd3kslwmag3erq7hqxt5aajjz: {
    'gol.delegation': 5135290206.0,
    'gol.lifetime': 6162279773.0,
    'heroes.pre_bostrom': 1865461494.0,
    total: 13163031473.0,
  },
  bostrom1wzqyjejz5px38vgqsegafrcexl3963q9dsgqh9: {
    'gol.relevance': 13098969682.0,
    total: 13098969682.0,
  },
  bostrom164k2s2s2td6a30d3rvnv93scy3v29psw4j3ndm: {
    'heroes.euler4': 12701785716.0,
    total: 12701785716.0,
  },
  bostrom1mnqlcc7mslzxcf798acp80u2fxudsuzdn0px6s: {
    'gol.delegation': 5378290695.0,
    'gol.lifetime': 3666902099.0,
    'heroes.pre_bostrom': 3631810247.0,
    total: 12677003041.0,
  },
  bostrom1rya5547x4lrwc2npd63s89ny2dvhamv9dfx9x9: {
    'heroes.euler4': 12090950492.0,
    total: 12090950492.0,
  },
  bostrom18wn5kyxewwk6qh97493xtj9gufpmqserfahc37: {
    'heroes.euler4': 12063356572.0,
    total: 12063356572.0,
  },
  bostrom1ke6pp2kq2wx74tlh5fxqgp7af6jtsna3kktuh6: {
    'gol.delegation': 4104967246.0,
    'gol.lifetime': 3851891784.0,
    'heroes.pre_bostrom': 4018939291.0,
    total: 11975798321.0,
  },
  bostrom1kf0d64nuwsf2zeul5wkx78fsznplnlpsfh7fqw: {
    'investors.takeoff': 11673069511.0,
    total: 11673069511.0,
  },
  bostrom1evz2xfd6sam0kzz5qc5lje4s90vcgyyrzz47pm: {
    'gol.relevance': 11323309556.0,
    total: 11323309556.0,
  },
  bostrom1fpl40sref5vp8kfm7xkqlq5qc0v4xrjvk89kwa: {
    'gol.delegation': 53188072.0,
    'gol.lifetime': 6083030821.0,
    'heroes.pre_bostrom': 4982262138.0,
    total: 11118481031.0,
  },
  bostrom1d7n8znqg635yxnzlsycnt6kut8z5du5yftutrf: {
    'heroes.euler4': 10958899451.0,
    total: 10958899451.0,
  },
  bostrom1nywu6z26tpcrr2kcqe8z7t235wrfkhfcfhlzmk: {
    'gol.delegation': 4106198982.0,
    'gol.lifetime': 3137937218.0,
    'heroes.pre_bostrom': 3688752206.0,
    total: 10932888406.0,
  },
  bostrom1mzmzlzk4xpm6zy68c43e6hen98w07yhfedumgg: {
    'gol.relevance': 10780033350.0,
    total: 10780033350.0,
  },
  bostrom1nvr4qa7szsd3e7xfysn946gcqv5wyemlcxmxpw: {
    'gol.delegation': 5133236390.0,
    'gol.lifetime': 3297924061.0,
    'heroes.pre_bostrom': 2222757245.0,
    total: 10653917696.0,
  },
  bostrom1wt9h9wm3zf7yzsy68x7v8p973w02kw8yyurh55: {
    'gol.delegation': 2760107758.0,
    'gol.lifetime': 7777346692.0,
    total: 10537454450.0,
  },
  bostrom143x4d5wx50204zyreqg8ekgq3n3fcaxucacztp: {
    'investors.port': 9826875134.0,
    total: 9826875134.0,
  },
  bostrom16pdckvu70ufzvm8avd9anga6k35nu7axym02wp: {
    'heroes.euler4': 9792986284.0,
    total: 9792986284.0,
  },
  bostrom1udal5nr3lz7mg7j7k79se4rz0tsjj8lur45q99: {
    'gol.load': 2666930610.0,
    'gol.relevance': 7057738490.0,
    total: 9724669100.0,
  },
  bostrom1ucl2c39dpwqm9pp6cvmlazn2tkwavszhs27j96: {
    'gol.delegation': 2575695017.0,
    'gol.lifetime': 7109962804.0,
    'gol.load': 5891599.0,
    total: 9691549420.0,
  },
  bostrom1y83nga220nfjt9zz0mmqc90cd705az95n5cfwj: {
    'investors.port': 9608859331.0,
    total: 9608859331.0,
  },
  bostrom18ghjkwygsvjcsh20tc5zzhfttxxuex7a9lq8ps: {
    'investors.takeoff': 9561458741.0,
    total: 9561458741.0,
  },
  bostrom18txzlmkqf264a2awhey6lmeq0dtv5ex69d2fcy: {
    'heroes.euler4': 9333557553.0,
    total: 9333557553.0,
  },
  bostrom1pswgrf5ap0kld3lpun5z4x08wh7nmgamd8mgex: {
    'gol.delegation': 3282151788.0,
    'gol.lifetime': 5358993270.0,
    total: 8641145058.0,
  },
  bostrom1a4mzr2y2g0cc9f0uhyeh3ftmsfxzqwxfdqtd7c: {
    'gol.load': 119010306.0,
    'gol.sergeandmyself': 6001189000.0,
    'investors.port': 972470487.0,
    total: 7092669793.0,
  },
  bostrom1mmtt0cnsgwx3t90vs4tn9k08kw8xn4v3pggfu7: {
    'heroes.euler4': 6701991111.0,
    total: 6701991111.0,
  },
  bostrom1mryr27k3h8kqr5ahj82v0ym2xexdewfc9rmng8: {
    'heroes.euler4': 6310270182.0,
    total: 6310270182.0,
  },
  bostrom1gg73t0eyrkqf953waqxh6uqah62p46jyg82ulr: {
    'heroes.euler4': 5787292447.0,
    total: 5787292447.0,
  },
  bostrom184dur4s6pldvhvcyputu6yshsm09s6wmvylt8k: {
    'gol.relevance': 5728639830.0,
    total: 5728639830.0,
  },
  bostrom1g2d9xyuf7ddgaj4llxvg50pfhlsr9ehf2r8dr6: {
    'gol.delegation': 154956147.0,
    'gol.lifetime': 716488373.0,
    'heroes.pre_bostrom': 4818065010.0,
    total: 5689509530.0,
  },
  bostrom19vgwu99fdawejnedgsfx8dmxuc0z4emjf7a044: {
    'gol.lifetime': 5014404214.0,
    total: 5014404214.0,
  },
  bostrom1gxyf6tsjamnavmkfk43mwfzwscn4tgfkz8k85n: {
    'gol.comm_pool': 5000000000.0,
    total: 5000000000.0,
  },
  bostrom15n3t80p7eseld809f7fu3s9tlcezlymkfeu59n: {
    'heroes.pre_bostrom': 4294256393.0,
    total: 4294256393.0,
  },
  bostrom1s6v5ragv9gg3sq7j3aeqtyy82uaxv3y05hzhh8: {
    'gol.lifetime': 4273801138.0,
    total: 4273801138.0,
  },
  bostrom1jx0az02ccnt4mgj2r9vhvycsdjsztrrgdkwzr3: {
    'heroes.euler4': 4220671315.0,
    total: 4220671315.0,
  },
  bostrom1pjvkddp4fmx8ym5j7s7su8kn3zuqj255djzpja: {
    'gol.load': 22780851.0,
    'gol.sergeandmyself': 4000000000.0,
    total: 4022780851.0,
  },
  bostrom1mlqakhlxplhlezk80lph99wcy377j9dk2qx3gg: {
    'gol.sergeandmyself': 4000000000.0,
    total: 4000000000.0,
  },
  bostrom1nuc82t22xgp09rs2tdnlxxgm95pjg5matjwwye: {
    'gol.delegation': 5497646.0,
    'gol.lifetime': 3567926892.0,
    total: 3573424538.0,
  },
  bostrom1r90j4656xsug2hkj57a3knqcs9huh3ea88ykhp: {
    'heroes.euler4': 3475567070.0,
    total: 3475567070.0,
  },
  bostrom1w4tk9lj8qtx2x4xf4emgrnq950hnlajsxlnl3u: {
    'heroes.pre_bostrom': 3420409835.0,
    total: 3420409835.0,
  },
  bostrom1s8l0akn79kk74g32kf86stfsa08ck9qmm4v6ws: {
    'heroes.pre_bostrom': 3409436625.0,
    total: 3409436625.0,
  },
  bostrom10aqelwndkz9k8uawp26elxep64ayc5rgn24h7p: {
    'heroes.pre_bostrom': 3389782351.0,
    total: 3389782351.0,
  },
  bostrom1ap7zhu5gxlk7n3g97dqehm9nnt3mje3nr5jecs: {
    'heroes.pre_bostrom': 3368708754.0,
    total: 3368708754.0,
  },
  bostrom1j6he98h8xwnt2yp9eczhhuff3k3hvk98gr27ee: {
    'heroes.pre_bostrom': 3326309936.0,
    total: 3326309936.0,
  },
  bostrom1mskldfjlnup46adzss7lukfh3emm6z4lmqhk7z: {
    'heroes.pre_bostrom': 3275155354.0,
    total: 3275155354.0,
  },
  bostrom12ysvrknuwdr6737fnc06v875whfh52xj3ewaf2: {
    'heroes.pre_bostrom': 2961579452.0,
    total: 2961579452.0,
  },
  bostrom10trdf5eyfcmc9graltx4hmpgznhrm7hdz82k2n: {
    'heroes.pre_bostrom': 2941697143.0,
    total: 2941697143.0,
  },
  bostrom1zl0t5703q42qx7drxsgl9thjwlul5x6unjhwgn: {
    'heroes.euler4': 2742969308.0,
    total: 2742969308.0,
  },
  bostrom1hyjhy0tp6geral2g9vj9nyteglf8t5q42gfq3j: {
    'gol.load': 3927733.0,
    'gol.sergeandmyself': 200000000.0,
    'investors.port': 2184963106.0,
    total: 2388890839.0,
  },
  bostrom1jz57cgfr248y9w6sn76l7pugjkr6e7zh6y2grp: {
    'gol.sergeandmyself': 200000000.0,
    'investors.takeoff': 2178739020.0,
    total: 2378739020.0,
  },
  bostrom15gk8edxtvvp372flljk884fav55y8ehwru4u8w: {
    'investors.takeoff': 2279889403.0,
    total: 2279889403.0,
  },
  bostrom1d8mq46wt2yxsgwrmh6hhfgycl0537w8gggn47f: {
    'investors.port': 2182283065.0,
    total: 2182283065.0,
  },
  bostrom1wm4026rxqcrkh09k806m6y4lys942etx5cjz9z: {
    'heroes.pre_bostrom': 2128629825.0,
    total: 2128629825.0,
  },
  bostrom13q0m4hw6pmajqdqn4g464vzmst78sf55ktrp05: {
    'heroes.euler4': 2064986311.0,
    total: 2064986311.0,
  },
  bostrom1p0r7uxstcw8ehrwuj4kn8qzzs0yypsjwxgd445: {
    'gol.load': 26708583.0,
    'investors.port': 1992130580.0,
    total: 2018839163.0,
  },
  bostrom1ssu4wqtzvvmwcukcv7l8zxny647mdx03e0t57j: {
    'gol.sergeandmyself': 2001189000.0,
    total: 2001189000.0,
  },
  bostrom12reh000lje8y20wshqmgl8tg70qggt2ac7qz45: {
    'gol.sergeandmyself': 2000000000.0,
    total: 2000000000.0,
  },
  bostrom1hmrxmc27fu4ggdpvpxqtahn6uvtj38vuu77a02: {
    'gol.delegation': 10268322.0,
    'gol.lifetime': 1844228437.0,
    total: 1854496759.0,
  },
  bostrom1gw5kdey7fs9wdh05w66s0h4s24tjdvtc9v6vpe: {
    'gol.load': 43597835.0,
    'investors.takeoff': 1755881840.0,
    total: 1799479675.0,
  },
  bostrom1kajt7sxfpnfujm7ptj90654lmwz4sftpc9mp9a: {
    'investors.takeoff': 1743792737.0,
    total: 1743792737.0,
  },
  bostrom1y6huw3naar38u4rtgqmlh9smfu93gszst9tawp: {
    'gol.lifetime': 1688512495.0,
    total: 1688512495.0,
  },
  bostrom1jdmfxzpnqqlhjsju3mz7qsgvvdparw5acx7t62: {
    'heroes.pre_bostrom': 1664373777.0,
    total: 1664373777.0,
  },
  bostrom1smsn8u0h5tlvt3jazf78nnrv54aspged9h2nl9: {
    'grants.cyberdbot': 200000000.0,
    'heroes.pre_bostrom': 1454337644.0,
    total: 1654337644.0,
  },
  bostrom15kdrahda8qcyfa9xe8kt2f737m22x2sleslj5l: {
    'gol.delegation': 3552879.0,
    'gol.lifetime': 1628053769.0,
    total: 1631606648.0,
  },
  bostrom1uwfk6h06w8vnhmyp48vwcpgwncsec8yv3z0xyg: {
    'gol.delegation': 8204799.0,
    'gol.lifetime': 1494510816.0,
    total: 1502715615.0,
  },
  bostrom15kl5tv0smz5h8eewu5hs9mtnusz4dereyqxxtw: {
    'heroes.pre_bostrom': 1408569410.0,
    total: 1408569410.0,
  },
  bostrom1uew6fawa3ahu60tj5kspmr4u0zvljj69q4s3ps: {
    'heroes.pre_bostrom': 1380580057.0,
    total: 1380580057.0,
  },
  bostrom16qu2ymnzzjn05xc6yszjy50caaahcahdvmex5e: {
    'heroes.euler4': 1362390306.0,
    total: 1362390306.0,
  },
  bostrom1ezpth4mp3eeqdt49kgqd5ctr69xev6v2gykpur: {
    'heroes.pre_bostrom': 1351419074.0,
    total: 1351419074.0,
  },
  bostrom1avvkajdvmj9d8jpl0ga4scftjykeuhjpsa9kf5: {
    'heroes.pre_bostrom': 1334996609.0,
    total: 1334996609.0,
  },
  bostrom1gd9r9uhd8a5k2naudq4hua3vf3lkwhfrm63qhq: {
    'heroes.pre_bostrom': 1301510822.0,
    total: 1301510822.0,
  },
  bostrom1vrym7t34gs9t2dkd8z849zcymkj54kgq7pdf8z: {
    'heroes.pre_bostrom': 1231063676.0,
    total: 1231063676.0,
  },
  bostrom1lk3yjcn0lvwj9f2dj75m8y3smpq5s5zsnnj3nz: {
    'heroes.pre_bostrom': 1202315516.0,
    total: 1202315516.0,
  },
  bostrom1hqeqy4s039q0qcpayqcyaq5hyyvmph97t79m9n: {
    'gol.lifetime': 1190379955.0,
    total: 1190379955.0,
  },
  bostrom1mj0sj4eaar5qnjn3l05ep5wgq3l6agtvvqwvyk: {
    'gol.load': 226237413.0,
    'gol.relevance': 951997050.0,
    total: 1178234463.0,
  },
  bostrom1hk49ws6ded79xmwehv7yrw3q6mfj7kulafxqhr: {
    'heroes.pre_bostrom': 1108262797.0,
    total: 1108262797.0,
  },
  bostrom1t575qeee3qgshuf964qal057z77vljqef9tlck: {
    'investors.takeoff': 1099995800.0,
    total: 1099995800.0,
  },
  bostrom1n55zyf6wlvh8jp4wxqgx4ta283jx0e2n2tutgm: {
    'gol.load': 984682627.0,
    'gol.relevance': 114773762.0,
    total: 1099456389.0,
  },
  bostrom1vx9qctuxswd6ydcv4z5pcuuvct7y9l0nqq799x: {
    'heroes.pre_bostrom': 1083041319.0,
    total: 1083041319.0,
  },
  bostrom105zy26ze9gean4qukqlvhkv4mtcndc9t2xaydz: {
    'investors.takeoff': 1006206924.0,
    total: 1006206924.0,
  },
  bostrom19trgcp8uldtc5xtnpf0u7x7dk3t3jcp4y7cusm: {
    'grants.cyberdbot': 1000000000.0,
    total: 1000000000.0,
  },
  bostrom13uz23f4stcg8esqvvc7d2w9psxv0dya5xaq5ne: {
    'grants.cyberdbot': 1000000000.0,
    total: 1000000000.0,
  },
  bostrom178nsekn4qcdkqqmv95qlmp68kaqpga3zpsdnf4: {
    'grants.cyberdbot': 1000000000.0,
    total: 1000000000.0,
  },
  bostrom1duc9gthaeg82lx9pdf642g043xqhgxgxmfvwsz: {
    'gol.load': 1178320.0,
    'investors.port': 993141688.0,
    total: 994320008.0,
  },
  bostrom14h099ukgvp4fm9qs0xnmljzhevrmneq6m6cltv: {
    'gol.lifetime': 978084362.0,
    total: 978084362.0,
  },
  bostrom1a30w6j4m6g3s2c6zt02z56xynnuaqmn3ahwxuq: {
    'gol.posthuman': 200000000.0,
    'investors.takeoff': 774688373.0,
    total: 974688373.0,
  },
  bostrom1xpl2sx64ra5san4su0r0hj8z9eh5cf5dcv48qa: {
    'investors.port': 970654649.0,
    total: 970654649.0,
  },
  bostrom1hem3076xmat8ttr0cg0nnn2lghtc2p7xtzpj8s: {
    'investors.port': 951329198.0,
    total: 951329198.0,
  },
  bostrom1xhk0s2ynz2sq3ak3lr4u5gg0da4vyaxkfjhg7l: {
    'gol.lifetime': 924447759.0,
    total: 924447759.0,
  },
  bostrom1ydc5fy9fjdygvgw36u49yj39fr67pd9mv67ety: {
    'heroes.pre_bostrom': 894267502.0,
    total: 894267502.0,
  },
  bostrom1wkjn2nc4v5g3tpjj043wxtmeda90ql3yqqddav: {
    'heroes.pre_bostrom': 814730401.0,
    total: 814730401.0,
  },
  bostrom1gh09lmm8flkuu3w38mr4axvunnu6qqlapuwzrv: {
    'heroes.pre_bostrom': 760249650.0,
    total: 760249650.0,
  },
  bostrom1pmaltcu0x97x8j5klc8xluaapkzcvztcn2vkmw: {
    'gol.load': 2356640.0,
    'investors.takeoff': 734384390.0,
    total: 736741030.0,
  },
  bostrom1sm9sq4wnn62tk5yz0x3fvvx2ea9efguqwvdu64: {
    'gol.load': 128044091.0,
    'gol.relevance': 594091324.0,
    total: 722135415.0,
  },
  bostrom1n3mhyp9fvcmuu8l0q8qvjy07x0rql8q4uwev5z: {
    'investors.takeoff': 704276829.0,
    total: 704276829.0,
  },
  bostrom1m0tjgkrh4td9fcp8nnssu3rfdahzfgdshsall9: {
    'heroes.pre_bostrom': 682238027.0,
    total: 682238027.0,
  },
  bostrom1u3ap2d4ytcqrr6jlsjf380g3lvgldq4m64s7dg: {
    'gol.load': 2356640.0,
    'investors.takeoff': 673130864.0,
    total: 675487504.0,
  },
  bostrom1keny4peq77drtcdj6fscd9eknqcqyjmxqcr8t8: {
    'investors.takeoff': 647527281.0,
    total: 647527281.0,
  },
  bostrom1gyhwacrpqwues05pkavw7xwehcqsmgruy34zps: {
    'gol.relevance': 564067516.0,
    total: 564067516.0,
  },
  bostrom16w2xwdzf6tzucpwcjjqtg9656a4kkv7g2f6vk9: {
    'gol.delegation': 205345882.0,
    'gol.lifetime': 252779909.0,
    total: 458125791.0,
  },
  bostrom1nsffk0nt927vn7pdsk8epzjeqch3yfzkzq57pl: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1pt3a6xk432vs8lp0z6ya3qhqhxks99xe4sxxqq: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1nqxwnut0hdgsn3l9zaladaft5xt9c6ex9qquza: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1hmdjgtv3yq4qzyuk3ynyt42sjntma8hqarepjd: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1gfkztltd789py02jcd79dnkl252uej7x8pnx4p: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom10a9mqy8cu04nyz3nj934ck39p6u9ddjt9y5fve: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom18ghdg8y5hx6esxm6ndw3ywgtalvkmz48zeyc6z: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom14thj9udwenk5q8c5ey2urude2j54xud2a26rp3: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom19lsruwa85k93ahzkdwaydyrl6ehz9dmmkava0y: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom19wlc6vms3qkuy48wgg2dl06veahgxl47s8859j: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1ypzhtfsyuejekw0w0z207wyedqm3xqafc8nu7g: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1ysn8jyjv464fv4wpt40vezh7d5tw05tc9v858t: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1e4cnw86pl73k2sfv7uwauflfl42qzncn4akyv7: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom17jq8ev7n4e3zv8zdek5mccvxcgxxtkwva5vwtx: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1rc2647d9nftgwwh9n5vaw26lnjdrewc4dum68g: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1fzkp5pux48ux72wsgls9lhxp5cq2tqsy32hfec: {
    'gol.posthuman': 200000000.0,
    'gol.sergeandmyself': 200000000.0,
    total: 400000000.0,
  },
  bostrom1u2s32xsws9y2sskz6zvn7lawepdqxad5dcsyy6: {
    'gol.load': 10212105.0,
    'gol.relevance': 320482915.0,
    total: 330695020.0,
  },
  bostrom14z6glatrayal5j53632kcefskyge6ujmgshqfv: {
    'gol.lifetime': 327466267.0,
    total: 327466267.0,
  },
  bostrom1glgevt43557u6s7a2q9q40kzt8myw4ngcv6wr6: {
    'gol.load': 309112576.0,
    total: 309112576.0,
  },
  bostrom1g36u05ehktgw5h5udj8hyudd9057d9tx9r6zef: {
    'heroes.pre_bostrom': 303617054.0,
    total: 303617054.0,
  },
  bostrom14n625exc6ftee3t6tez3hj47lv49amjzan5pkr: {
    'gol.lifetime': 236797768.0,
    total: 236797768.0,
  },
  bostrom1z8mlsd42eaguaqf5gexy5a7jxgpwpgvz99qzft: {
    'investors.port': 218609970.0,
    total: 218609970.0,
  },
  bostrom1v2n3hg6s4resacgpemfyrd5hul2ntk7tftnk6u: {
    'investors.port': 218382779.0,
    total: 218382779.0,
  },
  bostrom1ufpz4dlnfawg0pr5dcq4hkrf9gs30mu0272p9w: {
    'investors.port': 218341548.0,
    total: 218341548.0,
  },
  bostrom1mkhugmqg9c0qe27stz3m4my9xq7e9pct0jyr3p: {
    'investors.port': 218115192.0,
    total: 218115192.0,
  },
  bostrom1yvlp9gzqaufwz02swp5wqsqhlmfcrcl8m22gzm: {
    'gol.load': 785547.0,
    'gol.sergeandmyself': 200000000.0,
    total: 200785547.0,
  },
  bostrom1wrtzl04mxs2en94ysc5p8mvqc5p0culr9w9m0n: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1wdk6rndatlj8dpxq799vmu50zft7xk5768ej2v: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1w7f07762zelhx4spzkndmygh2dz58g3nn58v7q: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pkhgpslggp3t0nrwskvgczxmavg7yejfullesx: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1xvsukg4tltfzduw0lsvgqyrhe6rzrlp472ln92: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1xc6jdlqd8gd9e6p73xdc2yw7ad3tnl8w7j4wsl: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1p4uyyk8sc2arl4n9egw3xrn9g7rpkzlerf4nlc: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pa0lcssmjkkycdvrhhzey5h94v34wuf9u4ths6: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pa0rcdua5v9d4vf09ksnnl7t96nfkf3w37k4dc: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pkxtd9xwmqwg08kjgz9xqyee3aw7j8upd89ah6: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pe42d4gkg7smf9na6dvh5twq9hgczsag4elx84: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1wh5gfxyz8x95qyjlc2s24h3czr60vfehwt49xa: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1x8r0ktn36dsxsadnp3863txyd9pksrp6awcuaa: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pljwxmmkhfrkzkdpmdjv29t6959sa77mjt0xz4: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1wr0mqeyea45u9av63srtvgr553nyg6l9p57ezr: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1xz2dkqrnrvq0ezc0vxtcvhwy39xr63vxzfedsr: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pfwja2fu2qcqvdws6rcdr9y6za46dklaxc83fh: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zr9urr3m42w7pu5h5xn7rvghcdk5vtrtmfw7wf: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1y795vkzvczrauey63vmvvcjr84l3fjheqd8f38: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zq9f4eczclr5cexrxdusfxxr6eumn2rlg2h4hs: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1znt56em2psvx8ylfpplcmpy5esrea08g2psvxm: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zg3xqymyrvlu5fmmyx8htdm84kqt50t7xdfmuj: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zejjt25xw9gwvhave95ykkvgqjtk7j56fe9cwh: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zcf0ph3k4p2q2pl32zqspy5f7jkgxd5s4kcd66: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1njpfrygstn6r5awzp77keyhkl3wfhzmvdz2pug: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1z6lhk6u25fceqylmgv65t5py0c8kclgkszmqyx: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1z3u9w3vyq6sw7ndxcdpjkgvlj0qaqm6spc3jmp: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1z33aen2znsmgy7wwzavwh2q0u7cu4e9xhky379: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1z0m5tcv4jde5acv0w4dms537wvntgj7x47zmeu: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1nscf69wvc0wkgqm8ma79qv8cr6j6zq3dt0t898: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1yq5h0gjxuup83hdz53utukwhkkz684mk3lx7cr: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zx70t5xqc8h4kmvrssdc2w82v9ksw0r82a99av: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ypvt8rf8md7qedvnk0p8cvd6mnffepst8f05p7: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1w0u83ty3nmflg9846zmh28u0hweccs3fzfpx0f: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1y9tvvunr7uaqjjw8u6xn5muypq6pheyz5gygm3: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1y7ku6vf9vq53pv4y6lw2zjn4d5ul3javm92whz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zy3nxgwtw9hr99tzfaxasgwklm9ev843fju9zl: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1yaastlp99jvqta2x5fngdzw6zur7khctd9gk3x: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ppzvqc7yf9lfs8cljqu6w992gct6d5h9jx5wsn: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1vpp9vy0fnxxw8yk5t2cctutpfv8pprvyhnjw90: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1vmfs06hv80gc8jcpzu93ld4494azendxfalh2g: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1u4427txgc9pulkuu0wk4v9cjxqa0dxee5az972: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qh6eavdzp5ffks2rvd5mjt3rdmjxg3qm5l4pw2: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1tz4yrvqlw87e74n783n0da4pttay2ypsfq6668: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1tyzmkpn0axquu4jlht3lllsmq03um8kn5cu5pt: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qkltelhy5zsr4kfrefvwsupxyt6y9skwjpd7h4: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1tx6dnqh0nnj05uuell7rhnwhennscehlnjylxv: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1teyn0utv6yhnwux44ycfvqh6z888pvjaz9cz6l: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1t9xfg2kurjlvnw86repcpte3shpgasdjge6a7t: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1t7gw3d2jz4qc6k6umgkazvfyeydjv7l6nym265: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1t5r4uhu0tscqw380t6hqmvrgyhlrj3u43vsm43: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1svwchckmrrkfl7py7l2fz3esla7lwmalld4yr2: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1spndx95pckqnmjss6emff6fyylasg66qzdfv6v: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qsm0ujra4vdwymc5vrtey2rvalyq8392h75nr4: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1sntt4y34tghn45vw97az7mz4vkcw8kgregkph7: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1sjtl9n7fqszta6p4w5y5yl7d4xqth26d8z2gjj: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1s4ytylknecgkp7sp3jgf2f5lj7mm2xxz0f9rl3: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1s05hsv6fxhkpclwxzgnlfjjk7qdm78nmpchj08: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1rzr7gnkm3kdqmzqya7ky98m8tnnmtet58deav0: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1r5gvlzt03a0a9rks3s57cppmfqx2lzjrquh3d0: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1r7grd2sazgzsy8y0c8wlsnjyhdc0sq4npr0v4q: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1r82whjffalh2hgmrayywc9g53es96n9e9893yv: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1u8yt9tvnwvvvlm36w97nyg27ue797hrvkz6eux: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qgkdm2asr0qey7jafqyqlnarvgndjws23fpkrh: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qf560sekun7kjsu4r0puey5u4fn90025f4q2p2: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1undz2328av9agfhaguqs8zxzejv5zqcc9grdmv: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1vesdfkzd36m08clhvkpusq4gv0dnqm28rm2hey: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1v9p7ukxpw2yjk7eqm8720vkgqq5qlk7w3jqgzu: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1r85972mwrka5w9ct6km58ww9jl9sh46fx559fu: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1prrtyfgrw2tzj9kua5eu7tnctt474m36eygux2: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1v2fzs3a8mvm4nhsfcpk85gt3d8rdacv6zggl9r: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1uz3xp4au0rxawmct6ffj0u3le7uglyza43appc: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1uym8hd4pum4zz2mpkf93y8435u725k97e2c38p: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1uspnj6pvq0u78d8qux8lz6p24dzm998phldqgv: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pv5clfxxfpqvuerquue2vgr2ndgh0h50jx898c: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ukgaegxryydqckt6fgrt60dajxq758x9pntmhh: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ueywgan39tj27pdysq0d54cqvcwyggf6eves07: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pvu65ccqw3fmgq88j2j485wc6qm96nx7h7ln4f: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pzp9nadejsjzfkpfl9k7ktu2cfhprw4r7qvd5p: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pzxnpyvxr6x9z64y6w3ctv0cvcx9sp90ehj960: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1pzyt3y68zcnvl7hkvuffqfedccaptf6nt2x8ya: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1q22fvnhna2zg2g2xm6s5587w8fvsh2zzfeey68: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1q2ajajyu0t544tudcnvk7xcznerhylz36p5vtc: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1q8ajen3vu5v5uu4czkvqasqvw827dz2nqq6d0s: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qc4t2q45f826cfc7k0y45ma8f5qrrfv2nkly33: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1qcy673rd8a27t48ry6evmv6as7fuetd8cyhnjn: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1nhkl9r84zjucmjswhddwq8zgpun5yks5mjk7xc: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom104rtaftr9xmx6dcakempk590tfxx4ytddqcj97: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1nfdyvvjy5hum8gpgmt29d0m5y4te3ekpfyz7pw: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom167hs9ma63wd02xym0vjw80uqlekt0cs54ass6v: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1809klqrjjrs8ch2gtf5hmmfhysspkrr894rmhm: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1808q4nv5qafkk8ec9h56wwth6sl5a5yd0elve6: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom17vw0qcu9j8t6jhh83sjrzj07nwg9nndfcpw9g0: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom17tksas9e4nkp25vgwcsd7z6y83pa6u7sddyyez: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom17ssaukj47urfj6c8cgywyz9xhgqz3tnpy7n5kv: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom17rg7cldfsqfmv53n6r7qmjmcge7ucxx2hhum0q: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom17qkfq2uwags5pzplrfqg2elhn9s0pfwja4mgeu: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom17lzmvgnahdncwnsx3dr7mss65qv6l9md2hy2qq: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom17llhhwjmglhhqumz72e4jap5cj39r8rwar7zzv: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom17kwvcuvar02ldacltr48373rm74z8lfkcq80vj: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom176q2gvutyk63dzknylcvdhp6lyjwu5w9fdmmev: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1756xr3jtsdve6vuwqgqdtmt6ws3td49gq7vc77: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom16zykdjnfjdy5cy3phuymmcghh8x24eah2cmmpu: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom16kqpk5jg9e5ucxv3e003mf48yuamw4ce5ww4la: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom16jvmfza0q60umemx2pv8s5kle2h8g9x6jj9fkq: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom16gxdwa79rsvkjaawpcpswthgahm56p4mpu8fe9: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom16gtt4cmrvg2us2rgecym9zt65zet7qq2euzvdf: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom180upuj8yp0326px2uys9r60xrlhpsa6fwryf80: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom185tek8r0ptelug0erducctzc4d83q5np3339k5: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom185y3kgv3e6t4sue0a55jyq88hv76th3urnca4c: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1a57rc9cnhdn4l843ca4990aqldh5wmq0uuetzg: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1damlfdlp8yynjvrmv6pd3t33f4currrhe4cm4z: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1d66wegxpllcsnrzv9saqugpk2dausa836qlqaz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1cmhrs08sqv0823mj057svp8jerp6avne6xmtrc: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1clr05sms7eklm509ger6jdzhgheafskv4wwxrg: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1clk49u6rvv8c40udn9qgp0s8hv5uvfcgxqptky: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1cjeg60652ueyu5222l3atmm8vrhlq4tfusnswk: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1amletsu7926696dpeay8wrewqgww5s7yunjjxr: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1a4krl6m7jg7ckczk94hh0wdlcezvpgwcwkrpcg: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom186tpdptavhzz7fg83vnm4r2y85cfqyg6sntmun: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1a2zr8qx60sl3srh982hjduse0l7pdcnhtl7juy: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom19rfaqnnz5fy3qct8qxzany94t2p7h0rrc75lmz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom197h938dvw52kzf2l7gke2u5tcz3grvlexeaq0y: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1959r3zp37k9yuz8kjtc4feayyfkkxpcv43mu0w: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom194097avwy9a6h0cvznev232z28h96rp2q3w3uc: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom18fudz7p6ah9yvdr4p9aflp8pgzngx84cem5lra: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom189tpr8vg4qvwn7fgs6szkqr25yrammvvlzx0zr: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom16dsvdl4jer9jyplelgz4x68hjvg5k647nrnc8z: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom15y8g5ggq2lslncdnlcscqygyesefmjy0t4cae3: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e08w7wrjn05gl06xkwnlfmud5f6trdkrf0drg5: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom15pax03gsgw84lsygpxyyvtthd8fswrqp7wjs7m: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom12w56mhf4nsfchquw0sgzwn72qkzvfvquxhg6dn: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom12w37894jf7rt2ck709rk8xa23lz3lg9tv93tlz: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom12vexhfe4m9p9szsqvzsalssf8sxluj6pqx8gr3: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom12pafl09rqzcw7d77qs63pg2nlsgvc3dsfxyzum: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom12d3klseftxsfs5xmvjju339enk8xcvg5y55qvl: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom12cq4xxcr6pmjz320aj7j8pn9l8vjeed63slcz5: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom12c8kh7aaz2gg0l4nkd73t58nhurdaren55atua: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom12arnsa069zhad0e40mlgy034n7aq77e2nxdven: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom124ll3q05an955eh26ygn34u5gtm9287arjrgj9: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom123wttw3lu62m7lcg23rkwr88cvv8apjmvkuj9f: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom10v8qjj6haddx7wmnr65mcsllu8xunkee7zg3z5: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom10r2sn7sasanc0tuw5wzupxvlpht5uv267her62: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom10pqp6py9pqtagyde9tnkkvakg3gqsnq7lgzxnp: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom10mja0qpcq6ze2nrchhh7w3n7g589sdktfu7p9m: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom10905rstxf5tzj0w6gguaa76ma7s32v48um4w9z: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom107v45crxqedhmf4yqa9y98v99wm2078fwtklsq: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom105c5jk0xwzlk4pexgaeqkxq0xadtqchc4lmev6: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom12zmexhujvw7j82la9uslzfl5g29erpysqt555s: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom130avjyegx7glgnqvraetqj6ztacrqv9kdwawkj: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom134llrhdus60n7853fn3ulmx6uy7evsx3ltzstt: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom150svyax8m8dwljwenc8xxtsg0avud07m5frlrz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom15njl9exppdfms5fg4zz9wafn4a95lfj30ftx58: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom15k9z24v0thrxffetjp97493ec89zlz7re07pjj: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom15cq4l7d6v43rtv493cps3c7tpsf26d83pseqwn: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom15ak23s0usm36hv2e4kajhe0yx592hw474p3gkq: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom15a8z9l8ufw8v8zdddfhesnmfzwwhua7axrmfxl: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom15884n6qmrwq8gjuwtqh6q8z7vx500n5s3djcv6: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom152xtf7tvw60tyhls32wwc9ypehqzf366zjkeeg: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom14tjwqqyha0c9r0s29dm0n0zdpdc4hfrvn7jqsq: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom13855g4d5pfhtnqemgp700qs36qpjdnaz0dx2m5: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom14q65nd2ft893dagpln4fq39wutv2xmpe3kc4w0: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom14jhjmhm2xmx6wyefju30auqvrs35hmnn2m8ewl: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom14c8rllqzmgyrkt8aeyanprl7g3adrlc2flq57a: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom148g7gmqvw5gfj7dmpjymtsw3j7gvasflqrsyx5: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom143dfs4ur5gjvwgx8l54jjz27rq57us0zz3hqj0: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom13s4egz6pqg6a88dunme3esuee5w7qlkjttcs08: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom13nef2p2g48kmj83m7f0ey76q6p9cdyrn03x4tz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1durjade4he9l23rw38azruzfttpmc8223n6r87: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ayc0pueqve9a3xjpgwh3p4l6hjlyvfpvclvldm: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e0c3ehnfzvcxvwh9fgzyfc2vqshy9w53du7hnv: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gffprg0nuvj9ve39s9rjhjp04u7k8xwan2tzff: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jmdtfuxag0deeuyxmj4ge2mqhvc200hlmzyztf: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jlu5u2sj0afddmcj7lxfy0ng466s8l2qdjz24v: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jgvy2vr96auye3er6n3tkhlu9hnxs6h3a38rpp: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jet9jf456dja8vqlhk407l06yvfehwzuvjaynv: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jdypscylf6hjlrlva03tx5vqqkcdnllg6rpza7: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jcj0w0e2khy0asm7dz8883xnepzmaxylwez7j2: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1j5wpswepyxva5vupvg05pq6jzqh7ttdvepkhp3: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1j39uxls4clq76ej7mk2tdskvql2tdp2zek8g89: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1hy8dexwz6ynlnnaj8ge7jvmzs4c6qmz6yh97lc: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1hjjsjgv7sx88mxfq9y44ql24xs76jj3w7y9ff8: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1h9zrqgwcjtul3s9qxf0hk0ym9alm44ztywkfyj: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1h9k38zr5a532jzl0hsker9qz785m822zmqw974: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gywad2frusetg26dyh83cfaevacravashyjwg6: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gws6ulm3u23txc6p8kv6ew6e2zn45udrwjkdqm: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gtma98yjsx43zc30j99t7t0tmdjt2gyp9e7g0r: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gp5s4tetnk7ng49g58uhn2znfpmgs4cfdq4ns3: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1gh8tenvx2sf9kj2c359ey6s5k0vzlrl7z4t59z: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jn8cp663fl0mv6k55xvy2lr6s0r57zg0v6gzr3: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jrp04lvvpzkyylr4l7e5xp256l9yd4hdhrpmls: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1jsdfjw0pjjj5thg7z2tpm30njusrlsagtac7rs: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1l9yx676futn4h28rxupsvk7evl9s68hrufetdw: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1n0wkta56ktj93nzpe9amkgrzq7rhzt3gy6m8uh: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1mzn966mlprxgkvayrqu209069px0qwz7gzn799: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1melp9r22clnjzzudd0thvs5zzveqfjyl9xfw54: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1m9x4gg6frezyeqldxdz4dvegxpcytxnapgykwu: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1m7y6qezuemqe6n535z7s80ee8zw4zg486vr53u: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1m3yh7j0jefp9dl26cz8fqexfg8tds39lh957jw: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1lk7m28npegzy0sz5s06sy95n27yzrj4d3rytdg: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1l8hx9jxul439uyjve4zn45nujtx9gmrw3za3vs: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1k24kf4reet2lstvmkx9a4j0r87xfuqeqh2lprz: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1knpgev72f2empt8j8gcn24my8kdasy2lcezjea: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1kkwwsk0v4h7tmccr4sdmpyl2j2gvfah6jzw7n8: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1kfz37afuxfyajrzk7xv6937xc0jsq4zd0ce7dz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ke9xxd3d6y0ttduac062zvv3r0jtakvhkvqcjz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1kae5k3nnzs3q7tar4ec3w29w4avd8saqujpjk5: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1kaaxhzud2ev7v69kwkf8vuvhst9a36wz5l424q: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1k879z65mwwwu4jause7galz0hlsqqj4rtah7r6: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ggh3zff5paq5c3r2j34mquq9lrcc7s0nvfnuwz: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1hjz37u09vws084cvwjlr5t27wmsrzm9tmfspu5: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1zyws7rajm9f3ql6jqqpzvnml0aym9vspd7tjxk: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1fn4ep44ud3edyh304ta38f55xd6pxswsw9e23z: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1eur22ds9gn06lgg9j3raqlzj8j2qzxx6vuje4x: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1evnwfeuqsgkjwe5qwe5acyy6m4w5ch03m3e7a6: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1f9nx8jrlx9pvns70edanu37mxtm359k606qyds: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1exv982mrkyfd967xv7fam7lq8h3ce3dvcnd4s3: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1erxn6kmz3xhfrv40m7lyp88v43qahqn8fy2xhn: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1fm842pq6zxaqs86fm30xv459gx7hm7f0ufujvz: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1exul86z68fzck5jra7jp8xdwvmfz5p9qyuh8um: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1epcd5upewwa7s20u6kgf9uywa2f7c3yj6zaeg0: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1f2uslv6udnjwyqkdngc7rswp5vkmgavzgy952g: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1fmpuldfmgj0a4dlkn0cdlap4h3qs7nljyph4rj: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ejkkddkuw63zn557l0lvqq3gmjcra53ealmy2x: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1fwx3u5w8qyzp8msv2n9umajgst86dnuqrsft0g: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e8dsx8yx9mjn8v8egz2n5vafkymqw98wy4z6re: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e63p9zdn5xks5ge9gj2y9gfkl5u0jgkvfrnhzl: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1fn5cutfgat9s9z6nz5ucnnq9aec82wvqpevsn5: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e3je4h3vkxywt2sf7mudelhf6zrx405yfgczkf: {
    'grants.cyberdbot': 200000000.0,
    total: 200000000.0,
  },
  bostrom1e20dl8se4v2ev79qcay3ag7uf5t98gampz0d48: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ftkw5j528j94cajk4rvqum3k7mhhmpvyc8k7yg: {
    'gol.posthuman': 200000000.0,
    total: 200000000.0,
  },
  bostrom1ftyx5guwf39fz4nc5n5nc9fua36cq344rm2d43: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom1f6tmyjffs0p7f6xeh25esjhawxu2kll9j00a47: {
    'gol.sergeandmyself': 200000000.0,
    total: 200000000.0,
  },
  bostrom19uryr2zuxcfdevfq429jng9a2evxwadlsky04c: {
    'gol.load': 1571093.0,
    'gol.relevance': 197186458.0,
    total: 198757551.0,
  },
  bostrom1jst67u54vquzvun3dawpmpwyx5ar8mayaak5j7: {
    'heroes.euler4': 181160067.0,
    total: 181160067.0,
  },
  bostrom1kk79xcsuah7ckvunku78094gyh7900ehkllkur: {
    'investors.takeoff': 173703544.0,
    total: 173703544.0,
  },
  bostrom1fhj7pkuvwflr7z7ngp2v9tj7g58aq2tjgvqfaj: {
    'gol.lifetime': 135097195.0,
    total: 135097195.0,
  },
  bostrom1l4krahjfp87exsmumzpnrfeaer2gsghpuwhfp6: {
    'gol.lifetime': 112519320.0,
    total: 112519320.0,
  },
  bostrom16s7gwc944patdynnfnvac0jh5u76wsnflty377: {
    'heroes.euler4': 77674844.0,
    total: 77674844.0,
  },
  bostrom137eezcxcyqgt6kshfdfuvnsdgwpujyje2l8qdz: {
    'investors.takeoff': 73708712.0,
    total: 73708712.0,
  },
  bostrom19wtkh935tx2ut2n4m6tjvkfvew4shaeezfl7em: {
    'gol.relevance': 59855356.0,
    total: 59855356.0,
  },
  bostrom190y8vwhmyjdnk7cfutcm7u8haw80xyejdwxsql: {
    'gol.load': 56952126.0,
    total: 56952126.0,
  },
  bostrom1rfh303jsl5297sxgs5txpt97lvxpjt4he3yy5r: {
    'gol.load': 54988260.0,
    total: 54988260.0,
  },
  bostrom1a2kn43nquua6gmr4n42htmjpceqj7fzushe28h: {
    'gol.relevance': 52853070.0,
    total: 52853070.0,
  },
  bostrom1uz39kh64w8p5df034fh6g5hwpdq8m0h5rx58he: {
    'investors.takeoff': 49997750.0,
    total: 49997750.0,
  },
  bostrom1u74s0z4ft63c6zz7g8xs62esdtdjkzuk4zf0rt: {
    'gol.relevance': 42282456.0,
    total: 42282456.0,
  },
  bostrom1n89a8avc4j7cv75lfsyynx5kazlk80ar5qcdx6: {
    'gol.delegation': 102666.0,
    'gol.lifetime': 40897910.0,
    total: 41000576.0,
  },
  bostrom12u6qgyrdsy4xmw04vfkkkh9a9tqzw66g59hudt: {
    'gol.load': 27886903.0,
    total: 27886903.0,
  },
  bostrom175tm6fucmk0e29cfgzaud6kqgksy25p884kjx0: {
    'heroes.pre_bostrom': 26259431.0,
    total: 26259431.0,
  },
  bostrom1v46pz6ddetfc3tnvdr28ss0l48jhazgynvp3c7: {
    'heroes.pre_bostrom': 14979552.0,
    total: 14979552.0,
  },
  bostrom13nrdf490fsuv4rwjp02hlyvalqjkn5u6xxqvqz: {
    'gol.load': 14925385.0,
    total: 14925385.0,
  },
  bostrom1fp9q2t9zn9gr5qjh9wljxuavtcsc4h8uqgnm2e: {
    'gol.load': 12175972.0,
    total: 12175972.0,
  },
  bostrom158mysantvvk7x65tfhhuu8q2va4ls34r54hk78: {
    'gol.load': 9819332.0,
    total: 9819332.0,
  },
  bostrom1clalfxmsrqdgnqq5uxlx0mc983pyp3wq4xl03c: {
    'gol.load': 4713279.0,
    total: 4713279.0,
  },
  bostrom13zf8kghx7h5fyttk6xdnjqn9c87z0rd36sfqjw: {
    'gol.load': 4320506.0,
    total: 4320506.0,
  },
  bostrom1wf8alywyvlxy2dqfe38efdpdmuscfpf4jxvg6r: {
    'gol.load': 4320506.0,
    total: 4320506.0,
  },
  bostrom1cc43k76udpd3xvpn6md76zz3ru6nvcnreeg2eq: {
    'gol.load': 3927733.0,
    total: 3927733.0,
  },
  bostrom1l5x6kerswths5xl0d6672y9yyn9mg2vw8yz59q: {
    'gol.load': 3142186.0,
    total: 3142186.0,
  },
  bostrom1qe4sguqg8ztlyy7psf7lzwr4ahph9j36k5hltz: {
    'gol.load': 2749413.0,
    total: 2749413.0,
  },
  bostrom1mn8ev805fde2xswght0snwfayfj9tn54dt24zg: {
    'gol.load': 2749413.0,
    total: 2749413.0,
  },
  bostrom16vc2mjjfxx2h5m6jpdp4nqfu5095qaeeq27qxj: {
    'gol.load': 2749413.0,
    total: 2749413.0,
  },
  bostrom1jmhqgld7luvuhh42wac24z6nlggjvkc7fzgs62: {
    'gol.load': 2356640.0,
    total: 2356640.0,
  },
  bostrom1dx8mvxfu6mpfnjehvdkp9lsvu78ek2gjr7r766: {
    'gol.load': 1571093.0,
    total: 1571093.0,
  },
  bostrom1eq2h9enjxsg5s08scr69lzwde8fl79snw20dc8: {
    'gol.load': 1571093.0,
    total: 1571093.0,
  },
  bostrom1qjknpllzp6w6qsxxjx52zxald29wpyzljznzdv: {
    'gol.load': 1571093.0,
    total: 1571093.0,
  },
  bostrom16862syzdtc6h0sxz92jhnjjas5yhhjgzvyewwd: {
    'gol.load': 1571093.0,
    total: 1571093.0,
  },
  bostrom1ec9da8avgv7tnvsx3v8g8veqrhlqq26lnncg5t: {
    'gol.load': 785547.0,
    total: 785547.0,
  },
  bostrom1c7pv6zyza76f3yhv0zvjc042e8m7w796qmvkse: {
    'gol.load': 785547.0,
    total: 785547.0,
  },
  bostrom1latzme6xf6s8tsrymuu6laf2ks2humqvfcz7m6: {
    'gol.load': 785547.0,
    total: 785547.0,
  },
  bostrom1y675phjdvw576ahlcmlamrzr28rjht9mx709lg: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1hq8d6pu2l6wkrwu9jxcqjcu55g8l43zxmrd6dk: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom14ysuwg6p4fzfaa6tg4s3hazu86pfevsw4cegce: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1kjhdx3nkh6krdhryvjzkq33xwh6wsyy7y8ark6: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1yslufs9kq762qty0wh62c8qtlpm2202ejmw4ef: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1jxpe7neu764uasz5y5u4lrr5jtltv430gjm9dw: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1y935ede6znmcvqdmn6mnl2aa5zxcqvvracsczu: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1c4h647a9rj8n9zye5ttmh9chpg66f3ffdvdds0: {
    'gol.load': 392773.0,
    total: 392773.0,
  },
  bostrom1kz6s2mp4rg7plj8p4qqe2wkegn4ldw3ak2a7qc: {
    'investors.takeoff': 233827.0,
    total: 233827.0,
  },
};

export default finalResultGoL;
